import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment-timezone";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CircleIcon from '@mui/icons-material/Circle';
import { Grid, TextField, InputAdornment, Button, Stack, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Divider, Checkbox } from "@mui/material";
import Paper from '@mui/material/Paper';
import SettingsIcon from '@mui/icons-material/Settings';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { getEdgeEventsDashBoard, getEdgeEventsFilterDashboard, downloadEdgeEventsTableDashbOard, clearEdgeEventsDownload } from "../../../actions/Users/authenticateEdgeEvents";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../../utils/constants";
import AssignmentIcon from '@mui/icons-material/Assignment';
import CustomLoader from "../../../components/Loader/CustomLoaders";
import "../../../components/InventoryDeployedTable/inventoryDeployed.css"
import "./AgentConfig.css";
import filter from "../../asset/image/filter.svg";
import { PER_PAGE_ITEMS, DEFAULT_PAGE_SIZE, NEW_PER_PAGE_ITEMS, } from "../../../constants/Constants";
import FilterEdgeEventsDialog from "../../../components/FilterEdgeEventsDialog";
import DateRangeTimePicker from "../../../vis/react-app/src/components/DateRangeTimePicker";
import { displayToastError } from "../../../server/request";
import { ERROR_GET_EDGE_EVENTS, ERROR_GET_EDGE_EVENTS_FILTER } from "../../../actions/error_types";
import { convertDateTimeIntoTimezone, getDecodeURI, getEncodedURI } from "../../../utils/util";
import { useHistory, useLocation } from "react-router-dom";
import JsonTooltip, { JsonDataTooltip } from "../../../components/JSONTooltip/JsonTooltip";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { StyledEngineProvider } from '@mui/material/styles';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import GetApp from "@material-ui/icons/GetApp";
import { Pagination } from "../../../components/Pagination";
import TuneIcon from '@mui/icons-material/Tune';
import Download from '../../asset/image/DownloadUsage.svg';
import { createAgentWan, getAgents, updateAgentWan, deleteAgentWan, deleteAgentConfig, copyAgentConfig, saveAgentConfig, agentConfigRowDownload, agentConfigSummary, deleteAgentConfigsBulk } from "../../../actions/Users/authenticateHub";
import ascSortingSelected from "../../../asset/image/ascSortingSelected.svg";
import descSortingSelected from "../../../asset/image/descSortingSelected.svg";
import AscSort from "../../../asset/image/AscSort.svg";
import DescSort from "../../../asset/image/DescSort.svg";
import download_icon from "../../../asset/image/download_icon.svg";
import delete_icon from "../../../asset/image/delete_icon.svg";
import setting_icon from "../../../asset/image/setting_icon.svg";
import copy_icon from "../../../asset/image/copy_icon.svg";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { toast } from 'react-toastify';
import { SAVE_AGENT_CONFIG, DELETE_AGENT_CONFIG, COPY_AGENT_CONFIG, AGENT_CONFIG_ROW_DOWNLOAD } from "../../../actions/types";
import yaml from 'js-yaml';

const AgentTable = (props) => {

    const AGENT_ID = 'agent_id';
    const AGENT_NAME = 'agent_name';
    const AGENT_CONFIG_NAME = 'agent_config_name';
    const CREATION_DATE = 'created_at';
    const LAST_SEEN = 'updated_at';
    const AGENT_CONFIG_VERSION = 'agent_config_version';
    const ASC_ORDER = "asc";
    const DESC_ORDER = "desc";

    const { authReducer, downloadAsCSV, setIsActionPopup, isEditActionPopup, setIsEditActionPopup, setUploadedFile, setIsAgentActionPopup, existingAgentName, setExistingAgentName,deleteAgentConfig, copyAgentConfig, saveAgentConfig, agentConfigRowDownload, agentConfigSummary, setExistingAgentConfigName, getAgents, setCurrentAgentId, setCurrentAgentName, sort, setSort, sortOrder, setSortOrder, searchValue, setSearchValue, total, setTotal, page, setPage, limit, setLimit, setAgentOrganizationId, setAgentOrganizationName, agents, setAgents,
        deleteAgentConfigsBulk, deleteAgentConfigLoading, copyAgentConfigLoading, saveAgentConfigLoading, agentConfigRowDownloadLoading, uploadAgentConfigLoading, getAgentsLoading, setAgentControllerVersion } = props

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    let _q = getDecodeURI(location?.search);
    const [openDelete, setOpenDelete] = useState<boolean>(false);
    const [selectedAgent, setSelectedAgent] = useState<any>(null);
    const [newAgentName, setNewAgentName] = useState('');
    const [newAgentId, setNewAgentId] = useState('');
    const [selectedAgents, setSelectedAgents] = useState<string[]>([]);
    const [agentsToDelete, setAgentsToDelete] = useState<any[]>([]);

    useEffect(() => {
        if (location && authReducer?.selectedOu?.id) {
            processQueryUrl()
        }
    }, [location, authReducer?.selectedOu?.id])

    useEffect(() => {
        if (!_.isEmpty(authReducer?.getAgents) && !authReducer?.getAgentsLoading) {
            setAgents(authReducer?.getAgents?.data || [])
            setTotal(authReducer?.getAgents?.totalCount)
            setAgentControllerVersion(authReducer?.getAgents?.agentControllerVersion || '');
        }
    }, [authReducer?.getAgents])

    const processQueryUrl = () => {
        let _q = getDecodeURI(location?.search);
        if (_q.ouId && authReducer?.selectedOu?.id !== _q.ouId) {
            return
        }
        
        setSearchValue(_q.search ? _q.search : '');

        let _limit = _q.limit && '' != _q.limit.trim() ? parseInt(_q.limit) : 15;
        if (_limit != limit) {
            setLimit(_limit);
        }

        let _page = _q.page && '' != _q.page.trim() ? parseInt(_q.page) : 0;
        if (_page != page) {
            setPage(_page);
        }

        if (_q.search && _q.search.trim() !== '') {
            setSearchValue(_q.search);
        }

        if (_q.sort && _q.sort != sort) {
            setSort(_q.sort)
        }

        if (_q.sortOrder && _q.sortOrder != sortOrder) {
            setSortOrder(_q.sortOrder)
        }

        getAgents(authReducer?.selectedOu?.id, { search: _q.search, page: _page + 1, pageSize: _limit, sortBy: sort, sortOrder: sortOrder, 'isHub4': true})
    }

    const handlePagination = (e, value) => {
        let params: any = getDecodeURI(location?.search);
        params.page = value - 1;
        setPage(value - 1)
        doNavigate(location.url, params);
    };

    const doNavigate = (pathname, params = {}) => {
        history.push({ pathname: pathname, search: `?${getEncodedURI(params)}` });
    }

    const handlePerPageChange = (e: any) => {
        let _perPage = parseInt(e.target.value);
        if (Number.isInteger(_perPage)) {
            let params: any = getDecodeURI(location?.search);
            params.page = 0;
            params.limit = _perPage;
            setPage(0);
            setLimit(_perPage);
            doNavigate(location.url, params);
        }
    };

    const setSorting = (event: any, field: any, order: any,) => {
        if (event && event.currentTarget) {
            let params: any = getDecodeURI(location?.search);
            params.page = 0;
            params.sort = field;
            params.sortOrder = order;

            setPage(0);
            setSort(field);
            setSortOrder(order);

            doNavigate(location.url, params);
            // getAgents(authReducer?.selectedOu?.id, { search: searchValue, pageSize: limit, page: 0, sortBy: field, sortOrder: order });
        }
    };

    const switchSorting = (event: any, field: any) => {
        let order = ASC_ORDER;
        if (sort === field) {
            order = ASC_ORDER === sortOrder ? DESC_ORDER : ASC_ORDER;
        }
        let params: any = getDecodeURI(location?.search);
        params.page = 0;
        params.sort = field;
        params.sortOrder = order;

        setPage(0);
        setSort(field);
        setSortOrder(order);

        doNavigate(location.url, params);
        // getAgents(authReducer?.selectedOu?.id, { search: searchValue, pageSize: limit, page: 0, sortBy: field, sortOrder: order });
    };
    // const handleCopyRow = (agent) => {
    //     setSelectedAgent(agent);
    //     copyAgentConfig(agent.organization_id, agent.agent_id);
    // };
    const handleCopyRow = (row: any) => {
        setSelectedAgent(row);

        setAgents((prevAgents) => {
            const index = prevAgents.findIndex(agent => agent.agent_id === row.agent_id);

            const copiedAgent = {
                ...row,
                agent_id: `${row.agent_id}-copy`,
                agent_name: `${row.agent_name}-copy`,
                old_agent_id: row.agent_id,
                isNew: true,
            };

            const updatedAgents = [...prevAgents];
            updatedAgents.splice(index, 0, copiedAgent);

            return updatedAgents;
        });
    };
    const handleDeleteClick = (agent: any) => {
        setSelectedAgent(agent);
        setOpenDelete(true);
    };
    const handleDeleteConfirm = () => {
    if (selectedAgent) {
        deleteAgentConfig(selectedAgent.organization_id, selectedAgent.agent_id);
        setOpenDelete(false);
        setSelectedAgent(null);
    }
    };
    const handleGearIconClick = (row: any) => {
        setAgentOrganizationId(row["organization_id"]); 
        setAgentOrganizationName(row["organization"]); 
        setExistingAgentConfigName(row["deviceId"]); 
        setIsActionPopup(true); 
        setIsEditActionPopup(true); 
        setCurrentAgentId(row["agent_id"]); 
        setCurrentAgentName(row['agent_name']);
        agentConfigSummary(row["organization_id"], row["agent_id"]);
        agentConfigRowDownload(row["organization_id"], row["agent_id"]);
    }
    useEffect(() => {
        if(!_.isEmpty(authReducer.deleteAgentConfig) && (authReducer?.deleteAgentConfig?.status == 200 || authReducer?.deleteAgentConfig?.success == true)){
            processQueryUrl();
            toast.success("Agent config has been deleted successfully!", { position: toast.POSITION.BOTTOM_LEFT });
            dispatch({type: DELETE_AGENT_CONFIG, payload: {}})
        }
    },[authReducer.deleteAgentConfig])

    useEffect(() => {
        if (!_.isEmpty(authReducer.copyAgentConfig) && authReducer.copyAgentConfig.success == true) {
            // const copiedAgent = {
            //     ...authReducer.copyAgentConfig?.data,
            //     agent_id: authReducer.copyAgentConfig?.data?.new_agent_id,
            //     agent_name: selectedAgent?.agent_name,
            //     isNew: true,
            //     old_agent_id: selectedAgent?.agent_id,
            //     old_agent_name: selectedAgent?.agent_name,
            //     organization_id: selectedAgent?.organization_id
            // };
            // setNewAgentId(authReducer.copyAgentConfig?.data?.new_agent_id);
            // setAgents((prevAgents) => {
            //     const index = prevAgents.findIndex(agent => agent.agent_id === selectedAgent?.agent_id);
            //     if (index === -1) {
            //         return [...prevAgents, copiedAgent];
            //     }

            //     const updatedAgents = [...prevAgents];
            //     updatedAgents.splice(index, 0, copiedAgent);
            //     return updatedAgents;
            // });
            processQueryUrl()
            toast.success("Agent config has been copied successfully!", { position: toast.POSITION.BOTTOM_LEFT });
            dispatch({type: COPY_AGENT_CONFIG, payload: {}})
        }
    }, [authReducer.copyAgentConfig]);

    const handleAgentIdChange = (e) => {
        setNewAgentId(e.target.value)
    };
    const handleAgentNameChange = (e) => {
        setNewAgentName(e.target.value)
    };

    const handleAgentFieldChange = (agentId, field, value) => {
        if(field == 'agent_id') {
            setAgents((prev) =>
                prev.map((agent) =>
                    agent.agent_id === agentId && agent.isNew  ? { ...agent, [field]: value } : agent
                )
            );
            setNewAgentId(value)
        } else {
            setAgents((prev) =>
                prev.map((agent) =>
                    agent.agent_name === agentId && agent.isNew  ? { ...agent, [field]: value } : agent
                )
            );
            setNewAgentName(value)
        }
    };

    const handleSaveEditedAgent = (row, index) => {
        const payload:any = {};
        if (row.agent_id) {
            payload.agent_id = row.agent_id;
        }
    
        if (row.agent_name) {
            payload.agent_name = row.agent_name;
        }
        copyAgentConfig(row.organization_id, row.old_agent_id, payload);
        setSelectedAgent(null);
    };

    useEffect(() => {
        if (!_.isEmpty(authReducer.saveAgentConfig)) {
            processQueryUrl();
            setNewAgentName('');
            setNewAgentId('');
            toast.success("Agent config has been updated successfully!", { position: toast.POSITION.BOTTOM_LEFT });
            dispatch({type: SAVE_AGENT_CONFIG, payload: {}})
        }
    }, [authReducer.saveAgentConfig]);
    
    useEffect(() => {
        if (!_.isEmpty(authReducer?.uploadAgentConfig)) {
            processQueryUrl();
        }
    }, [authReducer.uploadAgentConfig])

    const handleDownloadReport = (agent) => {
        agentConfigRowDownload(agent.organization_id, agent.agent_id);
    }

    const downloadYaml = (data: any, fileName: string = 'agent-config') => {
        try {
            const yamlStr = yaml.dump(data);
            yamlStr.replace("|", "");
            const blob = new Blob([yamlStr.replace("|","")], { type: 'text/yaml;charset=utf-8' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (err) {
          console.error('YAML conversion/download failed:', err);
        }
      };
    
    const createYamlFile = (data: any, fileName: string = 'agent-config.yaml'): File => {
        const yamlStr = yaml.dump(data, {
            lineWidth: -1,
            noRefs: true,
        });
        const blob = new Blob([yamlStr.replace("|", "")], { type: 'text/yaml;charset=utf-8' });
        const file = new File([blob], fileName, { type: 'text/yaml' });
        return file;
    };

    useEffect(()=> {
        if(!_.isEmpty(authReducer?.agentConfigRowDownload)) {
            if(!isEditActionPopup){
                downloadYaml(authReducer.agentConfigRowDownload, 'agent-config.yaml');
            }
            else {
                const file = createYamlFile(authReducer.agentConfigRowDownload);
                // setUploadedFile(file);
            }
            dispatch({type: AGENT_CONFIG_ROW_DOWNLOAD, payload: {}})
        }
    }, [authReducer.agentConfigRowDownload])

    const handleDeleteSelectedAgents = () => {
        const fullAgents = agents.filter(agent => selectedAgents.includes(agent.agent_id));
        setAgentsToDelete(fullAgents);
        setOpenDelete(true);
    };

    const handleDeleteConfirmBulk = () => {
        if (!_.isEmpty(agentsToDelete)) {
            deleteAgentConfigsBulk(agentsToDelete[0]?.organization_id, agentsToDelete);
            setOpenDelete(false);
            setSelectedAgents([]);
            setAgentsToDelete([]);
        }
    };

    const selectedOrgId = selectedAgents.length
        ? agents.find(a => a.agent_id === selectedAgents[0])?.organization_id
        : null;
    
    return (
        <Fragment><StyledEngineProvider injectFirst>
            <Grid container >
                <Button
                className="delete-selected-agents"
                    variant="contained"
                    onClick={() => handleDeleteSelectedAgents()}
                    disabled={selectedAgents.length === 0}
                    sx={{
                        backgroundColor: selectedAgents.length === 0 ? '#e0dddd' : '#244C84',
                        color: selectedAgents.length === 0 ? '#888' : '#fff',
                        '&:hover': {
                            backgroundColor: selectedAgents.length === 0 ? '#e0dddd' : '#1f3f6d',
                        }
                    }}
                    style={agents?.length == 0 ? { right: '170px' } : { right: '210px' }}
                >
                    Delete Selected Agents
                </Button>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <div className="menuScroll">
                        <Box>
                            <Pagination
                                rowsPerPageOptions={NEW_PER_PAGE_ITEMS}
                                count={total ? total : 0}
                                rowsPerPage={limit}
                                page={page + 1}
                                onPageChange={handlePagination}
                                onRowsPerPageChange={handlePerPageChange}
                            />
                        </Box>
                        <TableContainer className="usageReports-FleetDashboard loginHistory-tableContainer deployed-container white-bg deployed-table-headers" style={{ overflowY: 'auto', height: 'calc(100vh - 285px)'}}>
                            <Table aria-label="simple table">
                                <TableHead className="usageReports-tableHead">
                                    <TableRow className="UsageReports-tableRow login-tableRow">
                                        <TableCell style={{ width: "5%" }}>
                                            <Checkbox
                                                size="small"
                                                checked={
                                                    selectedAgents.length > 0 &&
                                                    agents.filter(a => a.organization_id === selectedOrgId).length === selectedAgents.length
                                                }
                                                indeterminate={
                                                    selectedAgents.length > 0 &&
                                                    selectedAgents.length < agents.filter(a => a.organization_id === selectedOrgId).length
                                                }
                                                onChange={(e) => {
                                                    const checked = e.target.checked;

                                                    if (checked) {
                                                        if (selectedAgents.length > 0) {
                                                            // select all in the same org
                                                            const selectedOrgId = agents.find(a => a.agent_id === selectedAgents[0])?.organization_id;
                                                            const sameOrgAgents = agents.filter(a => a.organization_id === selectedOrgId);
                                                            setSelectedAgents(sameOrgAgents.map(a => a.agent_id));
                                                        } else {
                                                            // select all from first org found
                                                            const firstOrgId = agents[0]?.organization_id;
                                                            const sameOrgAgents = agents.filter(a => a.organization_id === firstOrgId);
                                                            setSelectedAgents(sameOrgAgents.map(a => a.agent_id));
                                                        }
                                                    } else {
                                                        setSelectedAgents([]);
                                                    }
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell" style={{width:"5%"}}>
                                            <span className="align-items-center">
                                                <span className="login-history-dp-name font-wt-900" id='cursor-auto' >ORGANIZATION</span>
                                            </span>
                                        </TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                            <span className="align-items-center">
                                                <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, AGENT_ID)}>AGENT ID</span>
                                                <Grid className="sort-icon-margin">
                                                    <img src={sort === AGENT_ID && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                        className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, AGENT_ID, ASC_ORDER)} />
                                                    <img src={sort === AGENT_ID && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                        className="sortingImages" onClick={(event) => setSorting(event, AGENT_ID, DESC_ORDER)} />
                                                </Grid>
                                            </span>
                                        </TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                            <span className="align-items-center">
                                                <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, AGENT_NAME)}>AGENT NAME</span>
                                                <Grid className="sort-icon-margin">
                                                    <img src={sort === AGENT_NAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                        className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, AGENT_NAME, ASC_ORDER)} />
                                                    <img src={sort === AGENT_NAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                        className="sortingImages" onClick={(event) => setSorting(event, AGENT_NAME, DESC_ORDER)} />
                                                </Grid>
                                            </span>
                                        </TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                            <span className="align-items-center">
                                                <span className="login-history-dp-name font-wt-900" >AGENT CONFIG VERSION</span>
                                                <Grid className="sort-icon-margin">
                                                    <img src={sort === AGENT_CONFIG_VERSION && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                        className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, AGENT_CONFIG_VERSION, ASC_ORDER)} />
                                                    <img src={sort === AGENT_CONFIG_VERSION && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                        className="sortingImages" onClick={(event) => setSorting(event, AGENT_CONFIG_VERSION, DESC_ORDER)} />
                                                </Grid>
                                            </span>
                                        </TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                            <span className="align-items-center">
                                                <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, LAST_SEEN)}>LAST SEEN</span>
                                                <Grid className="sort-icon-margin">
                                                    <img src={sort === LAST_SEEN && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                        className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, LAST_SEEN, ASC_ORDER)} />
                                                    <img src={sort === LAST_SEEN && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                        className="sortingImages" onClick={(event) => setSorting(event, LAST_SEEN, DESC_ORDER)} />
                                                </Grid>
                                            </span>
                                        </TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                            <span className="align-items-center">
                                                <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, CREATION_DATE)}>CREATION DATE</span>
                                                <Grid className="sort-icon-margin">
                                                    <img src={sort === CREATION_DATE && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                        className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, CREATION_DATE, ASC_ORDER)} />
                                                    <img src={sort === CREATION_DATE && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                        className="sortingImages" onClick={(event) => setSorting(event, CREATION_DATE, DESC_ORDER)} />
                                                </Grid>
                                            </span>
                                        </TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell hub4-agentConfig-service">
                                            <span className="align-items-center">
                                                <span className="login-history-dp-name font-wt-900" id='cursor-auto'>SERVICES</span>
                                            </span>
                                        </TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                            <span className="align-items-center">
                                                <span className="login-history-dp-name font-wt-900" id='cursor-auto'>OPERATIONS</span>
                                            </span>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {agents?.length > 0 &&
                                    // className="tableBody alertsTable-tableBody"
                                    <TableBody className="tableBody usage-tableBody">
                                        {
                                            agents?.length > 0 && agents.map((row, index) =>
                                                <TableRow className="loginHistory-tableRow new-deployed-usage-tr">
                                                    <TableCell>
                                                        <Checkbox
                                                            size="small"
                                                            checked={selectedAgents.includes(row.agent_id)}
                                                            disabled={
                                                                selectedAgents.length > 0 &&
                                                                agents.find(a => a.agent_id === selectedAgents[0])?.organization_id !== row.organization_id
                                                            }
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                const id = row.agent_id;
                                                                const orgId = row.organization_id;

                                                                setSelectedAgents(prev => {
                                                                    const selectedOrgId = prev.length
                                                                        ? agents.find(a => a.agent_id === prev[0])?.organization_id
                                                                        : null;

                                                                    if (checked) {
                                                                        if (prev.length === 0 || selectedOrgId === orgId) {
                                                                            return [...prev, id];
                                                                        }
                                                                        return prev; // block if org doesn't match
                                                                    } else {
                                                                        const updated = prev.filter(a => a !== id);
                                                                        return updated;
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <Tooltip title={<span className="font-size-12px">{row['organization']}</span>}>
                                                        <TableCell className="login-left-align inter-font text-center CF-cell hub4-agent-table-elipse">
                                                            {row?.organization}
                                                        </TableCell>
                                                    </Tooltip>
                                                    <Tooltip title={<span className="font-size-12px">{row['agent_id']}</span>}>
                                                        <TableCell className="login-left-align inter-font text-center CF-cell hub4-agent-table-elipse">
                                                            {row.isNew ? (
                                                                <TextField
                                                                value={row.agent_id}
                                                                onChange={(e) => handleAgentFieldChange(row.agent_id, 'agent_id', e.target.value)}
                                                                variant="standard"
                                                              />
                                                            ) : (
                                                                row.agent_id
                                                            )}
                                                        </TableCell>
                                                    </Tooltip>
                                                    <Tooltip title={<span className="font-size-12px">{row['agent_name']}</span>}>
                                                        <TableCell className="login-left-align inter-font text-center CF-cell hub4-agent-table-elipse">
                                                            {row.isNew ? (
                                                                <TextField
                                                                    value={row.agent_name}
                                                                    onChange={(e) => handleAgentFieldChange(row.agent_name, 'agent_name', e.target.value)}
                                                                    variant="standard"
                                                                />
                                                            ) : (
                                                                row.agent_name
                                                            )}
                                                        </TableCell>
                                                    </Tooltip>
                                                    <Tooltip title={<span className="font-size-12px">{row['agent_config_version']}</span>}>
                                                        <TableCell className="login-left-align inter-font text-center CF-cell hub4-agent-table-elipse">
                                                            {row['agent_config_version']}
                                                        </TableCell>
                                                    </Tooltip>
                                                    <Tooltip title={<span className="font-size-12px">{row['last_seen'] ? convertDateTimeIntoTimezone(row['last_seen'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : "-"}</span>}>
                                                        <TableCell className="login-left-align inter-font text-center CF-cell hub4-agent-table-elipse">
                                                            {row['last_seen'] ? convertDateTimeIntoTimezone(row['last_seen'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : "-"}
                                                        </TableCell>
                                                    </Tooltip>
                                                    <Tooltip title={<span className="font-size-12px">{row['created_at'] ? convertDateTimeIntoTimezone(row['created_at'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : "-"}</span>}>
                                                        <TableCell className="login-left-align inter-font text-center CF-cell hub4-agent-table-elipse">
                                                            {row['created_at'] ? convertDateTimeIntoTimezone(row['created_at'], authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : "-"}
                                                        </TableCell>
                                                    </Tooltip>
                                                    <Tooltip title={<span className="font-size-12px">{row['services'] && Array.isArray(row['services']) ? row['services']?.join(", ") : row['services']}</span>}>
                                                        <TableCell className="login-left-align inter-font text-center CF-cell hub4-agent-table-elipse">
                                                            {row['services'] && Array.isArray(row['services']) ? row['services']?.join(", ") : row['services']}
                                                        </TableCell>
                                                    </Tooltip>
                                                    <TableCell className="login-left-align inter-font text-center CF-cell">
                                                        <div style={{ display: "flex", justifyContent: "flex-start", gap: "5px", alignContent: "center", alignItems: "center" }}>
                                                            <Tooltip title='Edit'>
                                                                <span><img style={row.isNew && {cursor: 'auto'}} src={setting_icon} className="agent-table-edit-icon" onClick={() => { !row.isNew && handleGearIconClick(row)  }} /></span>
                                                            </Tooltip>
                                                            <Tooltip title='Copy'>
                                                                <span>
                                                                    {row.isNew ? (
                                                                        <CheckBoxIcon
                                                                            sx={{
                                                                                fontSize: 20,
                                                                                color: row.old_agent_id === row.agent_id ? '#80808057' : '#4caf50',
                                                                                cursor: row.old_agent_id === row.agent_id ? 'auto' : 'pointer',
                                                                            }}
                                                                            onClick={() => row.old_agent_id != row.agent_id && handleSaveEditedAgent(row, index)}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src={copy_icon}
                                                                            className="agent-table-edit-icon"
                                                                            onClick={() => handleCopyRow(row)}
                                                                            style={{
                                                                                opacity: selectedAgent ? 0.5 : 1,
                                                                                pointerEvents: selectedAgent ? "none" : "auto",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </span>
                                                            </Tooltip>
                                                            <Tooltip title='Download'>
                                                                <span><img style={row.isNew && {cursor: 'auto'}} src={download_icon} className="agent-table-edit-icon" onClick={()=> {!row.isNew && handleDownloadReport(row)}}/></span>
                                                            </Tooltip>
                                                            <Tooltip title='Delete'>
                                                                <span><img style={row.isNew && {cursor: 'auto'}} src={delete_icon} className="agent-table-edit-icon"onClick={() => {!row.isNew && handleDeleteClick(row)}}/></span>
                                                            </Tooltip>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>}
                                {(agents?.length === 0) && <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={12} className="noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>}

                            </Table>
                        </TableContainer>
                    </div>
                </Grid>
                <Dialog open={openDelete} onClose={() => {setOpenDelete(false); setSelectedAgents([]); setAgentsToDelete([])}} className="hubDeletePopup">
                    <DialogTitle className="hubDeleteTitle">
                        Delete {_.isEmpty(agentsToDelete) && selectedAgent?.agent_name}
                    </DialogTitle>
                    <Divider className="topologyDivider"/>
                    <DialogContent className="deletePopupGap">
                        <DialogContentText className="DeleteDialogText">
                        Do you confirm to proceed with the deletion?
                        </DialogContentText>
                        <TableContainer className="usageReports-FleetDashboard loginHistory-tableContainer deployed-container white-bg deployed-table-headers" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 395px)'}}>
                            <Table aria-label="collapsible sticky table" stickyHeader>
                                <TableHead className="usageReports-tableHead">
                                    <TableRow className="UsageReports-tableRow login-tableRow">
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">ORGANIZATION</TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">AGENT ID</TableCell>
                                        <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">AGENT NAME</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className="tableBody usage-tableBody">
                                    {!_.isEmpty(selectedAgent) && <TableRow className="loginHistory-tableRow new-deployed-usage-tr">
                                        <TableCell className="login-left-align inter-font text-center CF-cell">{selectedAgent?.organization}</TableCell>
                                        <TableCell className="login-left-align inter-font text-center CF-cell">{selectedAgent?.agent_id}</TableCell>
                                        <TableCell className="login-left-align inter-font text-center CF-cell">{selectedAgent?.agent_name}</TableCell>
                                    </TableRow>}
                                    {agentsToDelete?.map((agent, index) => (
                                        <TableRow key={index} className="loginHistory-tableRow new-deployed-usage-tr">
                                            <TableCell className="login-left-align inter-font text-center CF-cell">{agent?.organization}</TableCell>
                                            <TableCell className="login-left-align inter-font text-center CF-cell">{agent?.agent_id}</TableCell>
                                            <TableCell className="login-left-align inter-font text-center CF-cell">{agent?.agent_name}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions className="deleteActions">
                        <Button className="alertConfigDeleteCancel" onClick={() => {setOpenDelete(false); setSelectedAgents([]); setAgentsToDelete([])}}>Cancel</Button>
                        <Button id="threatKontrolSaveButton" onClick={!_.isEmpty(selectedAgent) ? handleDeleteConfirm : handleDeleteConfirmBulk}>Delete</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
            {deleteAgentConfigLoading || copyAgentConfigLoading || saveAgentConfigLoading || agentConfigRowDownloadLoading || uploadAgentConfigLoading || getAgentsLoading ? (
                <CustomLoader
                    showLoader={true}
                    loadingText={"Fetching data please wait..."}
                />
            ) : null}
        </StyledEngineProvider></Fragment>);
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    startDate: state?.authReducer?.newSummaryStartDate,
    endDate: state?.authReducer?.newSummaryEndDate,
    deleteAgentConfigLoading: state?.authReducer?.deleteAgentConfigLoading,
    copyAgentConfigLoading: state?.authReducer?.copyAgentConfigLoading,
    saveAgentConfigLoading: state?.authReducer?.saveAgentConfigLoading,
    agentConfigRowDownloadLoading: state?.authReducer?.agentConfigRowDownloadLoading,
    uploadAgentConfigLoading: state?.authReducer?.uploadAgentConfigLoading,
    getAgentsLoading: state?.authReducer?.getAgentsLoading,
});

export default withRouter(
    connect(mapStateToProps, {
        getEdgeEventsDashBoard,
        getEdgeEventsFilterDashboard,
        downloadEdgeEventsTableDashbOard,
        deleteAgentConfig,
        clearEdgeEventsDownload,
        getAgents,
        copyAgentConfig,
        saveAgentConfig,
        agentConfigRowDownload,
        agentConfigSummary,
        deleteAgentConfigsBulk
    })(AgentTable)
);